import { render, staticRenderFns } from "./CheckoutItem.vue?vue&type=template&id=084651da&scoped=true&"
import script from "./CheckoutItem.vue?vue&type=script&lang=js&"
export * from "./CheckoutItem.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutItem.vue?vue&type=style&index=0&id=084651da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084651da",
  null
  
)

export default component.exports